import { Component, OnInit } from '@angular/core';
import { IPackageBuider } from 'app/shared/Domains/packageBuilder';
import { SelectItem, ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { AppServiceManager } from 'common/services/appServiceManager';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { DatePipe } from '@angular/common';
import { Configuration } from 'config/config';
import { IUser } from 'app/shared/Domains/IUser';
import { AuthService } from 'common/services/auth.service';
import { UntypedFormGroup } from '@angular/forms';
import { ICompanyContactPackageBuider } from 'app/shared/Domains/companyContactPackageBuilder';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-package-builder',
  templateUrl: './package-builder.component.html',
  styleUrls: ['./package-builder.component.css']
})
export class PackageBuilderComponent implements OnInit {
  activeIndex: number = 0;
  items: any[] = [];
  package: IPackageBuider;
  memberSignUpForm: UntypedFormGroup;
  selectedLogo: any;
  packagesLogo: SelectItem[];
  user: IUser;
  currentUser = '';
  branchId = '';
  mode: string;
  zones: any;
  isMonthWisePackage: boolean = false;
  isPersonWisePackage: boolean = false;
  isCompanyWisePackage: boolean = false;
  packageID: string;
  packageFeeTypes: any[] = [];
  packageFeePersonWiseTypes: any[] = [];
  packageRegFeePersonWiseTypes: any[] = [];
  loading = false;
  groupFeePayByOnePerson = false;
  packageDurationTypes: any[] = [];
  packageDurationType: any;
  noOfMonths: number;
  noOfWeeks: number;
  noOfDays: number;

  constructor(private LanguageService: LanguageService, private route: ActivatedRoute, private router: Router, private confirmationService: ConfirmationService, private datePipe: DatePipe, public config: Configuration, private messageService: MessageService, private breadcrumbService: BreadcrumbService, private appServiceManager: AppServiceManager) {
    route.params.subscribe(
      params => {
        if (this.packageID === undefined) {
          this.packageID = params['id'];
        } else if (this.packageID !== params['id']) {
          this.packageID = params['id'];
          this.getPackageByID();
        }
        this.packageFeeTypes = [
          { label: 'Select Fee Type', value: null },
          { label: 'Per Month Fee', value: 'per Month Fee' },
          { label: 'Whole Package Fee', value: 'whole package fee' },
        ]
        this.packageFeePersonWiseTypes = [
          { label: 'Select Fee Type', value: null },
          { label: 'Per Person Fee', value: 'per Person Fee' },
          { label: 'Whole Package Fee', value: 'whole package fee' },
        ]
        this.packageDurationTypes = [
          { label: 'Months', value: 'months' },
          { label: 'Weeks', value: 'weeks' },
          { label: 'Days', value: 'days' },
        ]
        this.packageRegFeePersonWiseTypes = [
          { label: 'Select Registration Fee Type', value: null },
          { label: 'Per Person Registration Fee', value: 'per Person Registration Fee' },
          { label: 'Whole Package Registration Fee', value: 'whole package Registration fee' },
        ]
      });
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("PackageBuilderComponent", label);
  }
  ngOnInit() {
    this.InitObjects();
    if (this.package !== null && this.packageID !== undefined) {
      this.mode = 'edit';
      this.getPackageByID();
    } else {
      this.mode = 'add';
      this.breadcrumbService.setItems([
        { label: 'All Packages', routerLink: '/package-Builders' },
        { label: 'Add New Package' }
      ]);
    }
    this.steps();
    this.user = JSON.parse(localStorage.getItem('currentUser'));
    this.packagesLogo = [
      { label: 'Muscle', value: 'muscle' },
      { label: 'Gym', value: 'gym' },
      { label: 'Gym Builder', value: 'gymbuilder' },
      { label: 'Gymnasium', value: 'gymnasium' },
      { label: 'Dumbbell', value: 'dumbbell' },
      { label: 'Effort', value: 'effort' },
      { label: 'Monthly', value: 'monthly' },
      { label: 'Quarterly', value: 'quarterly' },
      { label: 'Half Yearly', value: 'halfyearly' },
      { label: 'Yearly', value: 'yearly' },
      { label: 'Night', value: 'night' },
      { label: 'Group', value: 'group' },
      { label: 'Family', value: 'family' },
      { label: 'Couple Monthly', value: 'couplemonthly' },
      { label: 'Couple Quarterly', value: 'couplequarterly' },
      { label: 'Couple Half Yearly', value: 'couplehalfyearly' },
      { label: 'Couple Yearly', value: 'coupleyearly' },
      { label: 'Student Monthly', value: 'studentmonthly' },
      { label: 'Student Quarterly', value: 'studentquarterly' },
      { label: 'Student Half Yearly', value: 'studenthalfyearly' },
      { label: 'Student Yearly', value: 'studentyearly' },
      { label: 'Youth', value: 'youth' },
      { label: 'Code', value: 'code' },
      { label: 'Optera', value: 'optera' },
      { label: 'Exergy', value: 'exergy' },
      { label: 'IBM', value: 'ibm' },
      { label: 'Elixir', value: 'elixir' },
      { label: 'Jazz', value: 'jazz' },
      { label: 'UBL HBL', value: 'ublhbl' },
      { label: 'Z Tech', value: 'ztech' },
      { label: 'Keep Truckin', value: 'keeptruckin' },
      { label: 'MCG', value: 'mcg' },
      { label: 'Shifa', value: 'shifa' },
      { label: 'ZTE', value: 'zte' },
      { label: 'ClaryIcon', value: 'claryicon' },
      { label: 'Site Effect', value: 'siteeffect' },
      { label: 'Zones', value: 'zones' },
      { label: 'TEO', value: 'teo' },
      { label: 'Radix Inova', value: 'radixinova' },
      { label: 'TEU', value: 'teu' },
      { label: 'Taekwondo', value: 'taekwondo' },
      { label: 'TecFolk', value: 'tecfolk' },

    ];
  }

  InitObjects() {
    this.package = new IPackageBuider();
    this.package.companyContactPerson = new ICompanyContactPackageBuider();
    this.package.registerationFee = 0;
    this.package.packageFee = 0;
    this.package.noOfMembers = 1;
    this.package.noOfMonths = 0;
    this.package.noOfWeeks = 0;
    this.package.noOfDays = 0;
    this.packageDurationType = this.package.durationType;

  }

  steps() {
    this.items = [
      {
        label: 'Package Builder',
        command: (event: any) => {
          this.activeIndex = 0;
          // this.validateSignup();
        }
      },
      {
        label: 'Details',
        command: (event: any) => {
          this.activeIndex = 1;
          // this.validateSignup();
        }
      }
      // {
      //   label: 'Trainer Information',
      //   command: (event: any) => {
      //     this.activeIndex = 2;
      //     // this.validateSignup();
      //   }
      // },
      // {
      //   label: 'Identity Card',
      //   command: (event: any) => {
      //     this.activeIndex = 3;
      //   }
      // }
      // ,
      // {
      //   label: 'Fee Invoice',
      //   command: (event: any) => {
      //     this.activeIndex = 4;
      //   }
      // }
    ];
  }

  getPackageByID() {
    this.appServiceManager.get("packagesBuilder/" + this.packageID).subscribe((res: any) => {
      this.package = res;
      this.packageDurationType = this.package.durationType;
      this.selectedLogo = this.package.logo;
      this.groupFeePayByOnePerson = this.package.groupFeePayByOnePerson || false;
      this.selectSubcription(this.package.packageType);
      this.getZonesByBranchID();
      this.breadcrumbService.setItems([
        { label: 'All Packages', routerLink: '/package-Builders' },
        { label: this.package.packageName }
      ]);
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  getZonesByBranchID() {
    this.currentUser = localStorage.getItem('currentUser');
    const currentUserObj = JSON.parse(this.currentUser);
    this.branchId = currentUserObj.branch;
    this.appServiceManager.get("act/" + this.branchId + "/get-zones").subscribe((res: any) => {
      this.zones = res.response;
      this.setPackageBuilderZones();
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  setPackageBuilderZones() {
    let packageZone = this.package.zones.filter(z => z.IsSelect == 1);
    console.log(packageZone);
    let updatedZone = [];
    this.zones.forEach(element => {
      let zoneInfo = packageZone.filter(z => z.id == element.id);
      if (zoneInfo.length > 0) {
        element.IsSelect = 1;
      }
      updatedZone.push(element);
    });
    this.zones = updatedZone;
  }

  updateZoneSelection(event, value, index) {
    if (event) {
      this.zones[index].IsSelect = 1;
    }
    else {
      this.zones[index].IsSelect = 0;
    }
  }

  updateAccessControl() {

    this.confirmationService.confirm({
      message: "Are you sure you want to update package ?",
      accept: () => {
        this.appServiceManager.put("packagesBuilder/" + this.packageID + "/zone", this.zones).subscribe((res: any) => {
          if (res) {
            this.getPackageByID();
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Package Successfully Updated' });
          }
        },
          (error: any) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    });
  }

  update(form: any) {
    if (form.valid) {
      this.confirmationService.confirm({
        message: "Are you sure you want to update package ?",
        accept: () => {
          this.package.logo = this.selectedLogo;
          this.package.modifiedBy = AuthService.getLoggedInUserId();
          this.package.activityBy = this.user.name;
          this.package.type = 'Update Package';
          this.package.scope = 'Package';
          this.package.initiatedFrom =  'Package Builder';
          this.package.groupFeePayByOnePerson = this.groupFeePayByOnePerson;
          this.package.durationType = this.packageDurationType;
          if (this.package.durationType === 'month') {
            this.package.noOfWeeks = 0;
            this.package.noOfDays = 0;
          }
          if (this.package.durationType === 'weeks' ) {
            this.package.noOfMonths = 1;
            this.package.noOfDays = 0;
          }
          if (this.package.durationType === 'days' ) {
            this.package.noOfMonths = 1;
            this.package.noOfWeeks = 0;
          }
          this.appServiceManager.put("packagesBuilder/" + this.packageID, this.package).subscribe((res: any) => {
            if (res) {
              this.getPackageByID();
              this.messageService.clear();
              this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Package Successfully Updated' });
            }
          },
            (error: any) => {
              this.messageService.clear();
              this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
            });
        }
      });
    }
    else {
      //  // Form validation error handling
      Object.keys(form.controls).forEach(controlName => {
        const control = form.controls[controlName];
        control.markAsTouched(); // Mark the control as touched to display the validation error messages
      });
    }
  }



  selectSubcription(packageType) {
    this.package.packageType = packageType;
    switch (this.package.packageType) {
      case 'Month Wise Package':
        this.isMonthWisePackage = true; // input is disabled
        this.isCompanyWisePackage = true;
        break;
      case 'Person Wise Package':
        this.isPersonWisePackage = true; // input is disabled
        this.isCompanyWisePackage = true; // input is disabled
        break;
      case 'Company Package':
        this.isPersonWisePackage = true; // input is disabled
        break;

      default:
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "No Package is Selected Please go back and select the package" });
        break;
    }
    if (this.package.packageType == 'Month Wise Package') {

    }
    else if (this.package.packageType == 'Month Wise Package') {
      this.isCompanyWisePackage = true; // input is disabled
    }
    this.validateSignup();
  }

  validateSignup() {
    if (this.activeIndex === 0) {
      this.activeIndex = 1;
    }
  }

  reverse() {
    if (this.activeIndex === 1) {
      this.activeIndex = 0;
    } else if (this.activeIndex === 2) {
      this.activeIndex = 1;
    }
  }

}
